import { cx } from '@linaria/core';
import { useRef, useCallback } from 'react';
import { usePM2DisplayContext, pm2ConfigStore } from '@pm2/store';
import { InMemoryNavigationProvider } from '@provider/navigation';
import { useSpeechSynthesisConfig } from '@provider/speech-synthesis';
import { tanstackQueryClient } from '@provider/tanstack';
import { isPlatformNodeJS } from '@utils/common';
import { useEntryKey, postProcessOpgavekompleksetEntry, opgavekompleksetEntryDataSchema, getEntriesForComponentQueryKey, ComponentDisplayContext } from '@utils/component-framework';
import { assertRefObject } from '@utils/react';
import { wrapper } from './comp.root.style.js';
import { Router } from './comp.router.js';
import { jsx } from 'react/jsx-runtime';

function PM2OpgavekompleksetComponent(props) {
  const internalRef = useRef(null);
  const rootRef = props.ref ?? internalRef;
  assertRefObject(rootRef);
  const {
    inLightbox
  } = usePM2DisplayContext();
  const [, onResetEntry] = useEntryKey({
    componentEnvelope: props.component.envelope,
    defaultEntryKey: props.component.entryKey,
    schema: opgavekompleksetEntryDataSchema,
    postprocessEntry: entry => postProcessOpgavekompleksetEntry(entry, {
      state: "valid",
      data: props.component.data,
      envelope: props.component.envelope
    }),
    onEntryKeyReset: useCallback(nextEntryKey => {
      props.node.component.entryKey = nextEntryKey;
    }, [props.node.component])
  });
  const handleResetEntry = useCallback(() => {
    const previousEntries = tanstackQueryClient.getQueryData(getEntriesForComponentQueryKey(props.component.envelope.ID));
    onResetEntry({
      attempt: previousEntries ? previousEntries.length + 1 : 1
    });
  }, [onResetEntry, props.component.envelope.ID]);
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  const speechConfig = useSpeechSynthesisConfig();

  //
  // NB: We override standalone configurations to match those specified by the
  // PM2 shell.
  //
  props.node.component.data.settings.standalone.speechSynthesis.primaryLanguage = speechConfig.languages?.[0] ?? props.node.component.data.settings.standalone.speechSynthesis.primaryLanguage;
  props.node.component.data.settings.standalone.speechSynthesis.secondaryLanguage = speechConfig.languages?.[1] ?? props.node.component.data.settings.standalone.speechSynthesis.secondaryLanguage;
  props.node.component.data.settings.standalone.audience = audience === "Grade1To3" ? "young" : "default";
  props.node.component.data.settings.standalone.accentColor = null;
  return /*#__PURE__*/jsx(ComponentDisplayContext.Provider, {
    value: inLightbox ? "lightbox" : "embedded",
    children: /*#__PURE__*/jsx("article", {
      ref: rootRef,
      className: cx(wrapper, inLightbox && "inLightbox"),
      children: /*#__PURE__*/jsx(InMemoryNavigationProvider, {
        basePath: `${isPlatformNodeJS() ? "/" : window.location.pathname}?opgavekomplekset-${props.component.envelope.ID}=/`,
        initialPath: "/",
        children: /*#__PURE__*/jsx(Router, {
          ...props,
          rootRef: rootRef,
          onResetEntry: handleResetEntry
        })
      })
    })
  });
}

export { PM2OpgavekompleksetComponent };
//# sourceMappingURL=comp.root.js.map
